import React , {useState , useEffect} from "react";
import s from "./HeroSection.module.css";
import { motion } from "framer-motion";
import About from "../About/About";
import ServiceSlider from "../Services/Services";
import ChooseUs from "../ChooseUs/ChooseUs";
import Team from "../Team/Team";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";

 const sharedAnimationProps = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  transition: { ease: "easeOut" },  
};
const HeroSection = () => {

  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(true);
    }, 3500); // 3.5 saniye

    return () => clearTimeout(timer); // Cleanup
  }, []);
  return (
    <>
    <div className={s.main_container}>
      <svg
        className={s.logo1}
        width="687"
        height="147"
        viewBox="0 0 687 147"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
       >
        <path
          d="M70.5438 1.50003L122.851 143.955H107.596L64.7669 22.5125L64.4138 21.5114H63.3523H61.6477H60.5862L60.2331 22.5125L17.4044 143.955L2.14872 143.955L54.4562 1.50003H70.5438Z"
          stroke="white"
          stroke-width="3"
        />
        <path
          d="M615.114 80.3977V143.955H600.5V1.5H684.716V14.125H616.614H615.114V15.625V64.7727V66.2727H616.614H678.182V78.8977H616.614H615.114V80.3977Z"
          stroke="white"
          stroke-width="3"
        />
        <path
          d="M495.614 132.33H565.42V144.955H479.5V2.5H564.284V15.125H495.614H494.114V16.625V65.7727V67.2727H495.614H559.739V79.8977H495.614H494.114V81.3977V130.83V132.33H495.614Z"
          stroke="white"
          stroke-width="3"
        />
        <path
          d="M376.472 144.5H333.086V2.04541H378.461C392.363 2.04541 404.165 4.91337 413.93 10.5787L413.934 10.5813C423.703 16.2028 431.195 24.2853 436.42 34.874L436.421 34.8763C441.646 45.4195 444.29 58.1065 444.29 72.9886C444.29 87.9633 441.623 100.769 436.35 111.456C431.082 122.084 423.429 130.24 413.374 135.96C403.327 141.628 391.048 144.5 376.472 144.5ZM347.7 130.375V131.875H349.2H375.336C387.548 131.875 397.797 129.519 405.996 124.708C414.177 119.907 420.281 113.063 424.287 104.218C428.278 95.4105 430.245 84.9858 430.245 72.9886C430.245 61.088 428.302 50.7588 424.36 42.0456C420.406 33.2594 414.476 26.484 406.575 21.7726C398.663 17.0065 388.885 14.6704 377.325 14.6704H349.2H347.7V16.1704V130.375Z"
          stroke="white"
          stroke-width="3"
        />
        <path
          d="M298.114 1.5V143.955H283.5V1.5H298.114Z"
          stroke="white"
          stroke-width="3"
        />
        <path
          d="M179.456 144.955L127.149 2.5H142.404L185.233 123.942L185.586 124.943H186.648H188.352H189.414L189.767 123.942L232.596 2.5H247.851L195.544 144.955H179.456Z"
          stroke="white"
          stroke-width="3"

        />
      </svg>
         <motion.p
          className={s.about_desc}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ ease: "easeOut", duration: 4 }}
         >
          Havacılık ve Savunma Sanayiinde AVIDEF ile Geleceğe Kanat Açın.
        </motion.p>
 
    </div>

    <About/>
    <ServiceSlider/>
    <ChooseUs/>
    <Team/>
    <Contact/>
    <Footer/>



    </>
  );
};

export default HeroSection;
